// import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import {
  Paper,
  ListItemButton,
  List,
  ListItemText,
  ListItemIcon,
} from "@mui/material";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import FormControl from "@mui/material/FormControl";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import TabIcon from "@mui/icons-material/Tab";
// import FormControlLabel from "@mui/material/FormControlLabel";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
// import Switch from "@mui/material/Switch";
import SampleView from "./SampleView";
import { TextField } from "@mui/material";
// import Scrollbars from "react-custom-scrollbars-4";
import DoneIcon from "@mui/icons-material/Done";

export default function ImportDialog(props) {
  return (
    <Dialog
      fullWidth={true}
      maxWidth={"md"}
      open={props.isOpen}
      onClose={props.onClose}
    >
      <DialogTitle>{props.importTitle}</DialogTitle>
      <DialogContent>
        <DialogContentText>{props.importSubtitle}</DialogContentText>
        <Box
          noValidate
          component="form"
          sx={{
            display: "flex",
            flexDirection: "column",
            m: "auto",
            width: "100%",
          }}
        >
          {props.sheetName === null ? (
            <Paper elevation={6} style={{ width: "100%", margin: 10 }}>
              <Stack
                padding={2}
                // direction="row"
                spacing={2}
                sx={{
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <List
                  sx={{
                    width: "100%",
                    // maxWidth: 360,
                    bgcolor: "background.paper",
                  }}
                  // style={{ width: "100%", margin: 10 }}
                  component="nav"
                  aria-label="available tabs"
                >
                  {props.workbook.SheetNames.map((m, idx) => [
                    <Divider key={idx} component="li" />,
                    <ListItemButton
                      style={{ border: 1 }}
                      key={idx + 1}
                      onClick={() => props.onWorksheetSelected(m)}
                    >
                      <ListItemIcon>
                        <TabIcon />
                      </ListItemIcon>
                      <ListItemText primary={m} />
                    </ListItemButton>,
                    <Divider key={idx + 2} component="li" />,
                  ])}
                </List>
              </Stack>
            </Paper>
          ) : (
            props.importData.length > 0 &&
            Object.keys(props.importData[0]).map((colName, idx) => (
              <Paper
                elevation={6}
                key={idx}
                style={{ width: "100%", margin: 10 }}
              >
                <Stack
                  padding={2}
                  direction="row"
                  spacing={2}
                  sx={{
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                  divider={<Divider orientation="vertical" flexItem />}
                >
                  <SampleView
                    data={props.importData.map((f) => f[colName])}
                    columnName={colName}
                  />
                  <Stack>
                    <FormControl sx={{ mt: 2, minWidth: 140 }}>
                      <InputLabel htmlFor={props.importFields[idx].name}>
                        Import As
                      </InputLabel>
                      <Select
                        autoFocus={idx === 0}
                        value={props.importFields[idx].selected}
                        onChange={(e) => props.onFldChange(e)}
                        label="maxWidth"
                        inputProps={{
                          name: props.importFields[idx].name,
                          id: props.importFields[idx].name,
                        }}
                      >
                        {props.importFields[idx].options.map((op) => (
                          <MenuItem key={op} value={op}>
                            {op}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    <FormControl sx={{ mt: 2, minWidth: 140 }}>
                      {props.importFields[idx].selected === "New Attribute" && (
                        <TextField
                          label="Attribute Name"
                          id={`${props.importFields[idx].name}`}
                          name={`${props.importFields[idx].name}`}
                          value={props.importFields[idx].attribute}
                          onChange={(e) => props.onAttributeChange(e)}
                        />
                      )}
                    </FormControl>
                  </Stack>
                </Stack>
              </Paper>
            ))
          )}

          {props.importSubtitle ===
            "Import Successful: Results shown below" && (
            <Paper elevation={6} key={0} style={{ width: "100%", margin: 10 }}>
              <Stack style={{ padding: 30 }}>
                <Typography variant="h6" gutterBottom color="primary.main">
                  You imported
                </Typography>
                {props.importStats.map((s, i) => (
                  <Stack direction="row" key={i}>
                    <Typography variant="subtitle1" color="primary.main">
                      {`${s.name}:  (${s.count})`}
                    </Typography>
                  </Stack>
                ))}
              </Stack>
            </Paper>
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        {props.importSubtitle !== "Import Successful: Results shown below" && (
          <Button startIcon={<ArrowBackIcon />} onClick={props.onClose}>
            Cancel
          </Button>
        )}
        <Button
          disabled={!props.sheetName}
          startIcon={
            props.importSubtitle ===
            "Import Successful: Results shown below" ? (
              <DoneIcon />
            ) : (
              <ArrowForwardIosIcon />
            )
          }
          variant="contained"
          onClick={props.onImportExcel}
        >
          {props.importSubtitle === "Import Successful: Results shown below"
            ? "Done"
            : "Continue"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
